module.exports = __webpack_public_path__ + "static/media/Video_icon.2758170d.svg";